export type SeasonOption = {
  label: string;
  value: string;
};

export type AssociatedGame = {
  label: string;
  date: string;
};

export const ACTIVE_SEASON_OPTIONS: SeasonOption[] = [
  { label: 'season_all_2026', value: 'season_all_2026' },
  { label: 'season_all_2025', value: 'season_all_2025' },
];

export const STATIC_ASSOCIATED_GAMES: Record<'football' | 'basketball', AssociatedGame[]> = {
  football: [
    { label: 'Duke vs Wake Forest', date: '2026-09-05' },
    { label: 'North Carolina vs Duke', date: '2026-10-17' },
    { label: 'Clemson vs Duke', date: '2026-11-14' },
  ],
  basketball: [
    { label: 'Duke vs Kentucky', date: '2026-11-10' },
    { label: 'Duke vs UNC', date: '2027-02-06' },
    { label: 'ACC Tournament', date: '2027-03-10' },
  ],
};
